module.exports = "/layout/app/images/logo-isotope.22068115.svg";